<template>
	<div class="RadioEntry" :class="{'is-selected': entry.selected, 'is-disabled': !enabled && !entry.required}">
		<BaseRadio
			:label="entry.title"
            :name="entry.key"
			class="RadioEntry-title"
			type="radio"
			v-model="entry.selected">
		</BaseRadio>
        <div class="RadioEntry-tagline" v-if="entry.tagline" v-html="entry.tagline"></div>
		<div class="RadioEntry-content" v-if="entry.selected">
			<slot/>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			entry: Object,
			enabled: Boolean
		}
	}
</script>

<style lang="scss" scoped>
	.RadioEntry {
		border: 2px solid var(--colorInputBorder);
		margin-bottom: 1.2em;
		padding: 2em;
		transition: all .25s ease-in-out;

		&.is-disabled {
			opacity: .5;
			pointer-events: none;
		}

		&.is-selected {
			border-color: var(--colorBrand);
		}

		&-title {
			position: relative;
			cursor: pointer;
			font-size: 1.25em;
			font-weight: 700;
			transition: all .25s ease-in-out;
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			margin-bottom: 0 !important;
			color: var(--colorBrandDark);
			@media (max-width: 500px) {
				font-size: 1.18em;
			}

			&:hover {
				color: var(--colorBrand);
			}
		}

        &-tagline {
            font-size: 1.24em;
            font-weight: bold;
            margin-top: .5em;
        }

		&-content {
			padding-top: 2em;
		}
	}
</style>